import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { theme: { type: String, default: "light" } }

  connect() {
    const saved = localStorage.getItem("theme") || "light"
    this.themeValue = saved
    document.documentElement.setAttribute("data-theme", saved)
  }

  toggle() {
    const next = this.themeValue === "light" ? "dark" : "light"
    this.themeValue = next
    localStorage.setItem("theme", next)
    document.documentElement.setAttribute("data-theme", next)
  }
}
